import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import logo from "../../../../../assets/logo.png";
import { TripsheetReport } from "domain/entities/tripsheet-report";
var extenso = require('extenso')

const MAX_ROWS_PER_PAGE = 12

const styles = StyleSheet.create({
  page: { padding: 35, fontSize: 10, fontFamily: "Helvetica" },

  headerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
  },

  logo: { width: 130, height: 15 },

  title: {
    fontSize: 14,
    textAlign: "center",
    marginVertical: 10,
    fontWeight: "bold",
  },

  infoRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
  },

  table: {
    marginTop: 10,
    borderWidth: 1,
    borderColor: "#000",
  },

  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#f0f0f0",
    borderBottomWidth: 1,
    borderColor: "#000",
  },

  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#ccc",
  },

  tableCell: {
    flex: 1,
    padding: 4,
    borderRightWidth: 1,
    borderColor: "#ccc",
    display: 'flex',
    alignItems: 'center'
  },

  tableCellNoBorder: {
    flex: 1,
    padding: 4,
  },

  descriptionCell: {
    flex: 2.5,
    padding: 4,
    borderRightWidth: 1,
    borderColor: "#ccc",
    justifyContent: "center",
    display: "flex",
  },

  lastCell: {
    borderRightWidth: 0,
  },

  bold: {
    fontWeight: "bold",
  },

  centerCell: {
    textAlign: "center",
  },

  logoUnderline: {
    borderBottomWidth: 1,
    borderColor: "#000",
    width: '100%'
  },

  backgroundGray: {
    backgroundColor: "#f0f0f0"
  },

  totalRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 5,
  },
});

type Props = {
  data: TripsheetReport;
};

const TripsheetReportPDF: React.FC<Props> = ({ data }) => {
  const totals = {
    kmTotal: 0,
  };



  const monthArray = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"]

  const rows = data.trips.flatMap((trip) => {

    totals.kmTotal += trip.distanceKm;
    
      return {
        client: trip.client,
        dateTrip: trip.dateTrip,
        locationDestination: trip.locationDestination,
        reason: trip.reason,
        distanceKm: trip.distanceKm,
        kmValueUnit: trip.kmValueUnit,
        tripValue: trip.tripValue
      };
    }
  );

  const pages = [];
  for (let i = 0; i < rows.length; i += MAX_ROWS_PER_PAGE) {
    pages.push(rows.slice(i, i + MAX_ROWS_PER_PAGE));
  }

  return (
    <Document>
      {pages.map((pageRows, pageIndex) => (
      <Page style={styles.page} size={'A4'}>
        {/* Header */}
        <View style={styles.headerRow} fixed>
          <Image src={logo} style={styles.logo} />
        </View>
        <View style={styles.logoUnderline} fixed/>

        <Text style={styles.title} fixed>
          Mapa de Km's – {String(data.month).padStart(2, "0")}/{data.year}
        </Text>

        {/* Info */}
        <View style={styles.infoRow} fixed>
          <View style={{ marginTop: 25, fontSize: 11, maxWidth: 270 }}>
            <Text>
              <Text style={{ fontWeight: 'bold' }}>Colaborador: </Text>
              {data.employee.name}
            </Text>
            <Text style={{ marginTop: 5 }}>
              <Text style={{ fontWeight: 'bold' }}>NIF: </Text>
              {data.employee.fiscalIdNumber}
            </Text>
            {/* <Text style={{ marginTop: 5 }}>
              <Text style={{ fontWeight: 'bold' }}>Morada: </Text>
              {data.employee.address}
            </Text>
            <Text style={{ marginTop: 5 }}>
              <Text style={{ fontWeight: 'bold' }}>Localidade: </Text>
              {data.locationOrigin}
            </Text> */}
          </View>
          <View style={{ marginTop: 25, fontSize: 11 }}>
            
            <Text style={{ marginTop: 5 }}>
              <Text style={{ fontWeight: 'bold' }}>Matrícula: </Text>
              {data.employee.carRegistration}
            </Text>
          </View>
        </View>

        {/* Declaration */}
        {pageIndex === 0 && (
          <>
            <Text style={{ marginTop: 25, marginBottom: 25, fontSize: 11 }}>
              <Text>Recebi de </Text>
              <Text style={{ fontWeight: "bold" }}>NimberTech IT Solutions Lda. </Text>
              <Text>a importância de </Text>
              <Text style={{ fontWeight: "bold" }}>{extenso(data.kmValueCalculated + data.supportTripsValue, { mode: 'currency', currency: { type: 'EUR' } })} </Text>
              <Text>referente a deslocações em viatura própria em serviço da empresa conforme discriminado.</Text>
            </Text>
          </>
        )}

        {pageIndex !== 0 && (
          <>
            <Text style={{ marginTop: 15, marginBottom: 25, fontSize: 11 }}>
            </Text>
          </>
        )}


        {/* Table */}
        <View style={styles.table}>
          {/* Table Header */}
          <View style={styles.tableHeader}>
            <Text style={[styles.tableCell, styles.bold, styles.centerCell]}>
              Data
            </Text>
            <Text style={[styles.tableCell, styles.bold, styles.centerCell]}>
              Origem
            </Text>
            <Text style={[styles.descriptionCell, styles.bold, styles.centerCell]}>
              Destino
            </Text>
            <Text style={[styles.tableCell, styles.bold, styles.centerCell]}>
              Motivo
            </Text>
            <Text style={[styles.tableCell, styles.bold, styles.centerCell]}>
              Distância
            </Text>
            <Text style={[styles.tableCell, styles.bold, styles.centerCell]}>
              Custo Km
            </Text>
            <Text style={[styles.tableCell, styles.bold, styles.centerCell]}>
              Valor
            </Text>
          </View>

          {/* Rows */}
          {pageRows.map((row, index) => (
            <View style={styles.tableRow} key={index}>
              <Text style={[styles.tableCell, styles.centerCell]}>{new Date(row.dateTrip).toLocaleDateString('pt-PT')}</Text>
              <Text style={[styles.tableCell, styles.centerCell]}>
                {
                  row.reason.toLowerCase() === "supporttrip" ?
                    row.client:
                      "(*1)"
                }
              </Text>
              <Text style={[styles.descriptionCell, styles.centerCell]}>
                {row.locationDestination}
              </Text>
              <Text style={[styles.tableCell, styles.centerCell]}>
                {row.reason.toLowerCase() === "supporttrip" ?
                    "Intervenção":
                      row.reason}
              </Text>
              <Text style={[styles.tableCell, styles.centerCell]}>
                {row.distanceKm % 1 === 0
                  ? row.distanceKm.toFixed(1)
                  : row.distanceKm.toString()
                }
              </Text>
              <Text style={[styles.tableCell, styles.centerCell]}>
                {row.kmValueUnit.toFixed(2)} €
              </Text>
              <Text style={[styles.tableCell, styles.centerCell]}>
                {row.tripValue.toFixed(2)} €
              </Text>
            </View>
          ))}

          {/* Totals */}
          {pageIndex === pages.length - 1 && (
            <>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCellNoBorder, styles.backgroundGray]} />
                <Text style={[styles.tableCellNoBorder, styles.backgroundGray]} />
                <Text style={[styles.tableCellNoBorder, styles.backgroundGray]} />
                <Text style={[styles.descriptionCell, styles.backgroundGray]} />{" "}
                <Text style={[styles.tableCell, styles.centerCell]}>
                  {totals.kmTotal % 1 === 0
                  ? totals.kmTotal.toFixed(1)
                  : totals.kmTotal.toString()} km
                </Text>
                <Text style={[styles.tableCellNoBorder, styles.backgroundGray]} />
                <Text
                  style={[styles.tableCell, styles.lastCell, styles.centerCell]}
                >
                  {(data.kmValueCalculated + data.supportTripsValue).toFixed(2)} €
                </Text>
              </View>
            </>
          )}
        </View>

        {
          <Text>(*1) {data.locationOriginFullString} </Text>
        }

        {/* End */}
        {pageIndex === pages.length - 1 && (
          <>
            <Text style={{ marginTop: 60, marginBottom: 10, fontSize: 11 }}>
              <Text>Lisboa, {monthArray[data.month -1]} {data.year}</Text>
            </Text>
          </>
        )}

        {/* Signatures */}
        {pageIndex === pages.length - 1 && (
          <>
            <View wrap={false} minPresenceAhead={80}>
              <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 25, marginBottom: 10, width: 500, alignSelf: 'center' }}>
                  {/* Assinatura do Responsável */}
                  <View >
                    <Text style={{ fontSize: 11, marginBottom: 5, marginLeft: 10 }}>Assinatura do responsável da Nimber</Text>
                    <View style={{ borderBottomWidth: 1, borderColor: '#000', minWidth: 230, paddingTop: 50 }} />
                  </View>
                  
                  {/* Assinatura do Colaborador */}
                  <View >
                    <Text style={{ fontSize: 11, marginBottom: 5, marginLeft: 10 }}>Assinatura do Colaborador</Text>
                    <View style={{ borderBottomWidth: 1, borderColor: '#000', minWidth: 230, paddingTop: 50 }} />
                  </View>
              </View>
            </View>
          </>
        )}

      <Text
        style={{
          position: 'absolute',
          fontSize: 10,
          bottom: 35,
          right: 35,
          textAlign: 'right',
        }}
        render={({ pageNumber, totalPages }) => `Página ${pageNumber}/${totalPages}`}
        fixed
      />


      </Page>
      ))}
    </Document>
  );
};

export default TripsheetReportPDF;
